export function viewAlgoType(data, algoTypeFilter) {
  let newData = [...data];

  if (algoTypeFilter.includes('SIGNAL') && !algoTypeFilter.includes('NORMAL')) {
    newData = data.filter((item) => item?.type === 'SIGNAL');
  } else if (
    algoTypeFilter.includes('NORMAL') &&
    !algoTypeFilter.includes('SIGNAL')
  ) {
    newData = data.filter((item) => item?.type !== 'SIGNAL');
  }

  return [...newData];
}
